import { CountryIconProps } from './types';

const LR = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3657)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.74316 4.36307H21.2573C20.5735 3.53502 19.7804 2.80073 18.9006 2.18127H5.0999C4.2201 2.80063 3.42702 3.53498 2.74316 4.36307Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 12.0005C0 12.3684 0.0174844 12.732 0.049875 13.0915H23.9501C23.9825 12.732 24 12.3684 24 12.0005C24 11.6327 23.9825 11.2691 23.9501 10.9097H0.049875C0.0174844 11.2691 0 11.6327 0 12.0005Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.30884 17.4546H22.6917C23.0451 16.7634 23.3332 16.0335 23.5484 15.2728H0.452148C0.667258 16.0335 0.955539 16.7634 1.30884 17.4546Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.0999 21.818H18.9005C19.7803 21.1986 20.5734 20.4643 21.2572 19.6362H2.74316C3.42702 20.4642 4.2201 21.1986 5.0999 21.818Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.452148 8.72782H23.5485C23.3333 7.96713 23.0451 7.23719 22.6918 6.54602H1.30888C0.955586 7.23719 0.667305 7.96713 0.452148 8.72782Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.73926 2.18192H18.9004C16.9486 0.807638 14.5687 0.00012207 12.0001 0.00012207C10.4349 0.00012207 7.69113 0.807638 5.73926 2.18192Z"
        fill="#D80027"
      />
      <path
        d="M11.4785 6.54532H22.6917C22.2926 5.76471 21.8107 5.03351 21.2573 4.36353H11.4785V6.54532Z"
        fill="#D80027"
      />
      <path
        d="M11.4785 10.9085H23.9504C23.8829 10.1593 23.7472 9.42976 23.5484 8.72668H11.4785V10.9085Z"
        fill="#D80027"
      />
      <path
        d="M0.451805 15.2737H23.5481C23.7469 14.5707 23.8826 13.8411 23.9501 13.0919H0.0498047C0.117305 13.8411 0.252961 14.5706 0.451805 15.2737Z"
        fill="#D80027"
      />
      <path
        d="M2.74297 19.6369H21.2571C21.8105 18.9668 22.2924 18.2356 22.6915 17.4551H1.30859C1.70764 18.2357 2.18961 18.9669 2.74297 19.6369Z"
        fill="#D80027"
      />
      <path
        d="M11.9999 24.0005C14.5685 24.0005 16.9484 23.193 18.9003 21.8187H5.09961C7.05148 23.193 9.43133 24.0005 11.9999 24.0005Z"
        fill="#D80027"
      />
      <path
        d="M0.451758 8.72692C0.252914 9.43004 0.117305 10.1596 0.0498047 10.9087H11.9999V-0.000366211C6.50711 -0.000366211 1.87638 3.6902 0.451758 8.72692Z"
        fill="#0052B4"
      />
      <path
        d="M7.14405 3.13049L7.92101 5.52182H10.4357L8.40138 6.99989L9.17829 9.39136L7.14405 7.91339L5.10973 9.39136L5.88682 6.99989L3.85254 5.52182H6.36705L7.14405 3.13049Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3657">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LR;
